import React from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import StyledTableCell from 'components/SummaryComponent/StyledTableCell';
import PriceComponent from 'components/PriceComponent';

function CardAdditionalComponent(props) {
  const { title, value } = props;

  return (
    <TableRow>
      <StyledTableCell component="th" scope="row">
        {title}
      </StyledTableCell>
      <StyledTableCell align="right">
        <strong>
          <PriceComponent value={value} />
        </strong>
      </StyledTableCell>
    </TableRow>
  );
}

export default CardAdditionalComponent;

CardAdditionalComponent.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};
